import "nprogress/nprogress.css";
import { StrictMode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import "simplebar/dist/simplebar.min.css";
import App from "./app";
import { Providers } from "./components/providers";
import ApplicationStoreProvider from "./contexts/application-store-context";
import { AuthProvider } from "./contexts/auth-provider";
import { SettingsProvider } from "./contexts/settings-context";
import "./sentry";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ApplicationStoreProvider>
          <AuthProvider>
            <SettingsProvider>
              <Providers>
                <App />
                <Toaster
                  position="top-center"
                  toastOptions={{
                    style: {
                      wordBreak: "break-word",
                    },
                  }}
                />
              </Providers>
            </SettingsProvider>
          </AuthProvider>
        </ApplicationStoreProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);

// ReactDOM.render(
//   <StrictMode>
//     <HelmetProvider>
//       <BrowserRouter>
//         <ApplicationStoreProvider>
//           <AuthProvider>
//             <SettingsProvider>
//               <Providers>
//                 <App />
//                 <Toaster
//                   position="top-center"
//                   toastOptions={{
//                     style: {
//                       wordBreak: "break-word",
//                     },
//                   }}
//                 />
//               </Providers>
//             </SettingsProvider>
//           </AuthProvider>
//         </ApplicationStoreProvider>
//       </BrowserRouter>
//     </HelmetProvider>
//   </StrictMode>,
//   document.getElementById("root"),
// );
